import { DATA_KEYS, PRODUCTIVITY_HOURS_PER_USER_PER_WEEK } from './constants'

const COMING_SOON = 'coming_soon'
const getSafeArray = (value) => (Array.isArray(value) ? value : [])

const getAvailabilityByDataKey = (dataAvailability = []) =>
  Object.fromEntries(getSafeArray(dataAvailability).map((entry) => [entry.dataKey, entry]))

export const getDataGap = (dataAvailability = [], dataKeys = []) => {
  if (!Array.isArray(dataAvailability)) throw new Error('AI risk report dataAvailability must be an array')

  const availabilityByKey = getAvailabilityByDataKey(dataAvailability)
  const gap = getSafeArray(dataKeys)
    .map((dataKey) => availabilityByKey[dataKey])
    .find((entry) => entry?.status !== 'assessed')

  if (!gap) return null

  return {
    status: gap.status,
    reason: gap.reason,
    requiredLicense: gap.requiredLicense,
  }
}

export const getEntitiesFlaggedCount = (findings = []) =>
  new Set(getSafeArray(findings).flatMap((finding) => finding.affectedEntityIds || [])).size

export const getFullDeploymentHours = (summary) =>
  Math.round((summary?.licensing?.licensedUsers ?? 0) * PRODUCTIVITY_HOURS_PER_USER_PER_WEEK * 10) / 10

export const getFindingAffectedCount = (findings = [], findingId) =>
  findings.find((finding) => finding.id === findingId)?.affectedEntityIds?.length ?? 0

export const MOCK_BACKED_AREAS = {
  COPILOT_CONFIGURATION: {
    dataKeys: [DATA_KEYS.RESTRICTED_SHAREPOINT_SEARCH, DATA_KEYS.COPILOT_STUDIO_AGENTS],
  },
  DEVICES: {
    dataKeys: [DATA_KEYS.MANAGED_DEVICES],
  },
}

export const buildMockGap = (dataAvailability, area) =>
  getDataGap(dataAvailability, area.dataKeys) ?? { status: COMING_SOON }
